import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';
import { MomentInput } from 'moment';
import { getTermText } from '../../../core/Plans/utils';
import { SERVICE_COLOR } from '../../../core/styles/variables';

interface WorkingNoticeConfirmProps {
  startDate?: MomentInput;
  endDate?: MomentInput;
  onClick: MouseEventHandler<HTMLAnchorElement>;
}

const WorkingNoticeLink = ({
  startDate,
  endDate,
  onClick,
}: WorkingNoticeConfirmProps) => {
  return (
    <ButtonLink onClick={onClick}>
      <strong>{T.translate('applicant.new.workingNotice')}</strong>
      {!!(startDate && endDate) && (
        <Typography component="span" variant="body2">
          ({getTermText({ startDate, endDate })})
        </Typography>
      )}
    </ButtonLink>
  );
};

export default WorkingNoticeLink;

const ButtonLink = styled.span`
  margin: 0;
  color: ${SERVICE_COLOR};
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
